




































import { Component, Prop, Vue } from "vue-property-decorator";

export enum colors {
  Red,
  White,
  Grey20
}

@Component
export default class IconArrow extends Vue {
  @Prop({ default: colors.White }) private color!: colors;
  @Prop({ default: 5 }) private strokeWidth!: number;
  @Prop({ default: 32 }) private width!: number;
  @Prop({ default: 32 }) private height!: number;

  private get strokeColor(): string {
    if (this.color === colors.Red) {
      return "#c7272d";
    } else if (this.color === colors.Grey20) {
      return "#58585a33";
    }
    return "#fff";
  }
}
